define([
  "globals",
  "base-view-model",
  "jquery",
  "knockout",
  "product-choice-view-model",
  "unveil"],
function(globals, baseViewModel, $, ko, ProductChoiceViewModel) {

  "use strict";

  function ProductGroupViewModel(data, groupChoices, optionId) {

    var self = this;
    ko.utils.extend(self, baseViewModel);

    // This field is used for serverTemplate as Id

    this.groupid = data.GroupId;
    this.name = data.Name;
    this.choices = [];
    this.groupVisibleLimit = 20;
    this.selectedChoice = ko.observable();
    this.allVisible = ko.observable(false);

    var load = function () {
      $.each(groupChoices, function (index, value) {
        var newChoice = new ProductChoiceViewModel(value, self, optionId);
        newChoice.visible(index < self.groupVisibleLimit);
        self.choices.push(newChoice);
      });
    };

    this.unselectAll = function () {
      $.each(self.choices, function (index, value) {
        value.selected(false);
      });
    };

    this.makeAllVisible = function() {
      for (var i = self.groupVisibleLimit, j = self.choices.length; i < j; i++) {
        self.choices[i].visible(true);
      }
      $("img").unveil();
      self.allVisible(true);
    };

    load();
  }

  return ProductGroupViewModel;

});
